import { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";

import { faFileAudio } from "@fortawesome/pro-light-svg-icons";
import { faFileVideo } from "@fortawesome/sharp-regular-svg-icons";

import { FileUploadComponent, IFileType } from "../../components/Shared";
import { FeatureLayout } from "../../components/Shared/Layouts/FeatureLayout/FeatureLayout";
import { translationKeys } from "../../models/app-translation-keys";
import { UploadFile } from "../../models/classes/upload-file.class";
import { AllLanguageOptions } from "../../models/constants/app-language-options.const";
import { IProgressedFileResult } from "../../models/interfaces";
import { useStore } from "../../stores/StoreContext";
import { TranscriptionUploadComponent } from "./TranscriptionUpload";

const RawTranscriptionPage: FunctionComponent = () => {
  const { budgetStore, transcriptionStore } = useStore();

  const allowedFileTypes: IFileType[] = [
    { labelKey: "video", value: "video/*", icon: faFileVideo },
    { labelKey: "audio", value: "audio/*", icon: faFileAudio },
  ];

  const transcriptionTranslationKeys = translationKeys.feature.transcription;

  const transcriptionUploadItem = (
    uploadFile: UploadFile,
    setIsFileProcessing: (id: string, isProcessing: boolean) => void,
    downloadFunction: (file: UploadFile, content: IProgressedFileResult) => void,
  ) => (
    <TranscriptionUploadComponent
      disabled={budgetStore.hasBudget === false}
      uploadFile={uploadFile}
      setIsFileProcessing={setIsFileProcessing}
      languageOptions={AllLanguageOptions}
      downloadFunction={downloadFunction}
    />
  );

  return (
    <FeatureLayout
      titleKey={transcriptionTranslationKeys.title}
      subTitleKey={transcriptionTranslationKeys.subTitle}
      descriptionKey={transcriptionTranslationKeys.description}
      hasPendingChanges={transcriptionStore.isAnyFileProgressing}
    >
      <FileUploadComponent
        files={transcriptionStore.uploadFiles}
        onChange={(files: any[]) => (transcriptionStore.uploadFiles = files)}
        disabled={budgetStore.hasBudget === false}
        showAllowedFileTypes={false}
        allowedFileTypes={allowedFileTypes}
        fileSizeLimitMB={1000}
        isSingleFileUpload={true}
        maxConcurrentProcessedFiles={1}
        uploadTemplate={transcriptionUploadItem}
        fileUploadAreaStyles={{ minHeight: "18rem" }}
      />
    </FeatureLayout>
  );
};

export const TranscriptionPage = observer(RawTranscriptionPage);
